import { PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';

export const tikTokAudienceRequired = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { profiles } = postGroup;
  const selectedSocialProfiles = profiles.filter(
    profile => profile.__typename === 'TikTokSocialProfile' && (!profile.tikTok || !profile.tikTok.privacyTarget)
  );
  if (selectedSocialProfiles.length) {
    return {
      profileId: null,
      variationId: null,
      severity,
      selectedSocialProfiles,
      message: PostEditorValidationMessages.tikTokAudienceRequired
    };
  }
  return false;
};
